import { SET_ACCOUNT_TYPES, SET_COUNTIES, SET_ORGANIZATION_DATA, SET_ROUTING_TYPES } from "./actionTypes"

export function setCountries(data) {
  return {
    type: SET_COUNTIES,
    payload: data,
  };
};
export function setAccountTypes(data) {
  return {
    type: SET_ACCOUNT_TYPES,
    payload: data,
  };
};
export function setRoutingTypes(data) {
  return {
    type: SET_ROUTING_TYPES,
    payload: data,
  };
};

export function setOrganizationData(data) {
  return {
    type: SET_ORGANIZATION_DATA,
    payload: data,
  };
};